
import React from "react";
// react library for routing
// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";
import { useTranslation } from '../../i18n/context';


function IndexHeader() {
  const { t } = useTranslation();
  return (
    <>
      <div className="header bg-info pt-5 pb-7">
        <Container>
          <div className="header-body">
            <Row className="align-items-center">
              <Col lg="6">
                <div className="pr-5">
                  <p className="text-white mt-4" >
                    <span style={{ fontSize: "55px", lineHeight: "3.5rem", fontFamily: "gilroy-black", fontWeight: "bold !important" }}>{t('common.home')}</span><br></br> <span style={{marginTop:"50px"}}>{t('common.control')}</span>
                  </p>
                  <div className="mt-5">
                    <Button
                      className="btn-neutral my-2"
                      color="default"
                      href="#explore"
                    >
                      {t('common.explore')}
                    </Button>

                  </div>
                </div>
              </Col>
              <Col lg="6">
                <Row className="pt-5">
                  <img
                    alt="..."
                    className="img-fluid"
                    src={require("assets/img/brand/Online-payment-receipt.png")}
                  />
                </Row>
              </Col>
            </Row>
          </div>
        </Container>
        <div className="separator separator-bottom separator-skew zindex-100">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
            version="1.1"
            viewBox="0 0 2560 100"
            x="0"
            y="0"
          >
            <polygon className="fill-default" points="2560 0 2560 100 0 100" />
          </svg>
        </div>
      </div>
    </>
  );
}

export default IndexHeader;
